import React from "react";
import CreateRole from "../Create";

const RoleDetail = () => {
  return <CreateRole isDetail={true} />;
};

export default RoleDetail;
